import {
  GET_SALES_EVENT_TYPES_REQUESTED,
  GET_SALES_EVENT_TYPES_SUCCEEDED,
  GET_SALES_EVENT_TYPES_FAILED,
  CREATE_SALES_EVENT_TYPE_REQUESTED,
  CREATE_SALES_EVENT_TYPE_SUCCEEDED,
  CREATE_SALES_EVENT_TYPE_FAILED,
  UPDATE_SALES_EVENT_TYPE_REQUESTED,
  UPDATE_SALES_EVENT_TYPE_SUCCEEDED,
  UPDATE_SALES_EVENT_TYPE_FAILED,
  DELETE_SALES_EVENT_TYPE_REQUESTED,
  DELETE_SALES_EVENT_TYPE_SUCCEEDED,
  DELETE_SALES_EVENT_TYPE_FAILED,
} from './constants'
import DataMapper from 'utils/dataMapper'
import { filter, values } from 'lodash'

export const defaultState = {
  byId: {},
  isLoading: false,
}

const state = (state = defaultState, { type, payload }) => {
  switch (type) {
    case GET_SALES_EVENT_TYPES_REQUESTED:
      return { ...state, isLoading: true }

    case GET_SALES_EVENT_TYPES_SUCCEEDED:
      const byId = DataMapper.objectsById(payload)
      return {
        ...state,
        byId,
        isLoading: false,
      }

    case GET_SALES_EVENT_TYPES_FAILED:
      return { ...state, isLoading: false }

    case CREATE_SALES_EVENT_TYPE_REQUESTED:
      return { ...state, isLoading: true }

    case CREATE_SALES_EVENT_TYPE_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)

      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case CREATE_SALES_EVENT_TYPE_FAILED:
      return { ...state, isLoading: false }

    case UPDATE_SALES_EVENT_TYPE_REQUESTED:
      return { ...state, isLoading: true }

    case UPDATE_SALES_EVENT_TYPE_SUCCEEDED: {
      const byId = DataMapper.objectsById(payload)
      return {
        ...state,
        byId: {
          ...state.byId,
          ...byId,
        },
        isLoading: false,
      }
    }

    case UPDATE_SALES_EVENT_TYPE_FAILED:
      return { ...state, isLoading: false }

    case DELETE_SALES_EVENT_TYPE_REQUESTED:
      return { ...state, isLoading: true }

    case DELETE_SALES_EVENT_TYPE_SUCCEEDED: {
      const allSalesEventTypes = values(state.byId)
      const salesEventTypesWithoutRemovedSalesEvent = filter(
        allSalesEventTypes,
        (salesEvent) => salesEvent.uuid !== payload[0].uuid
      )

      const byId = DataMapper.objectsById(
        salesEventTypesWithoutRemovedSalesEvent
      )
      return {
        ...state,
        byId,
        isLoading: false,
      }
    }

    case DELETE_SALES_EVENT_TYPE_FAILED:
      return { ...state, isLoading: false }

    default:
      return state
  }
}

export default state
